// use String.raw to ignore all string escape sequences, meaning that
// this text behaves like it was written directly in a /regex literal/.
// do not match regional indicators as single emojis because they are matched in pairs later
// \u20E3 is the combining enclosing keycap used in keycap sequences (0️⃣–9️⃣, #️⃣, *️⃣)
const matchSingleEmoji = String.raw`(?!\p{Regional_Indicator})(?:\p{Emoji_Presentation}|\p{Emoji}\uFE0F\u20E3?)`
// a "compound emoji" is one or more "single emojis" joined with a Zero Width Joiner (U+200D)
// OR, two regional indicators which make up a flag emoji.
const matchCompoundEmoji = String.raw`${matchSingleEmoji}(?:\u200D${matchSingleEmoji})*|\p{Regional_Indicator}{2}`

/** Matches compound emojis anywhere in a string (global). */
export const EMOJI_REGEX = new RegExp(`(${matchCompoundEmoji})`, "gu")

/** Matches a string that is exactly one compound emoji. */
export const SINGLE_EMOJI_REGEX = new RegExp(`^(${matchCompoundEmoji})$`, "u")

const TRAILING_EMOJIS_REGEX = new RegExp(
  `^(.*?)(?:\\s*((?:${matchCompoundEmoji})+))\\s*$`,
  "su"
)

export function splitTrailingEmojis(quip: string): {
  text: string
  emoji: string | null
} {
  const match = quip.match(TRAILING_EMOJIS_REGEX)
  if (!match?.[2]) {
    return { text: quip, emoji: null }
  }

  return { text: match[1], emoji: match[2] }
}
